import React from "react";
import classNames from "classnames";

import {FacebookIcon, InstagramIcon, LinkedinIcon, XIcon, YouTubeIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {FOOTER_TEST_IDS} from "@pg-mono/test-ids";

import {FooterContactBox} from "./FooterContactBox";
import {FooterMenuElement, IFooterMenuElement} from "./FooterMenuElement";
import {FooterPanelExpandable} from "./FooterPanelExpandable";

import * as styles from "./Footer.module.css";

const logoRp = require("./Logo-DefaultTextLite.svg");

export interface IProps {
    footerMenuData: IFooterMenuData;
    panelArrowDown: React.JSX.Element;
    hide?: boolean;
    publisherInfo?: string;
    contactInfoLines?: string[];
    className?: string;
    logoSrc?: string;
}

export interface IFooterMenuData {
    various: IFooterMenuElement[];
    cityOffers: IFooterMenuElement[];
    promotions: IFooterMenuElement[];
    info: IFooterMenuElement[];
    cooperation: IFooterMenuElement[];
    topArticles?: IFooterMenuElement[];
}

const panelTitles = {
    offers: "Oferty",
    promotions: "Oferty specjalne",
    info: "Informacje",
    cooperation: "Współpraca",
    topArticles: "Top artykuły"
};

const publisherInfo = "Wydawcą portalu rynekpierwotny.pl jest PropertyGroup Sp. z o.o.";

const contactInfoLines = ["Tel.: +48 22 825 60 71", "Kontakt w dni robocze: 9:00 – 17:00", "E-mail: biuro@rynekpierwotny.pl"];

export const Footer: React.FC<IProps> = (props) => {
    if (props.hide) {
        return null;
    }

    const socialIcons = [
        {
            icon: <FacebookIcon fill="#fff" size="3" />,
            url: "https://www.facebook.com/rynekpierwotnypl/"
        },
        {
            icon: <InstagramIcon fill="#fff" size="3" />,
            url: "https://www.instagram.com/rynekpierwotny/"
        },
        {
            icon: <LinkedinIcon fill="#fff" size="3" />,
            url: "https://www.linkedin.com/company/rynekpierwotny-com/"
        },
        {
            icon: <YouTubeIcon fill="#fff" size="3" />,
            url: "https://www.youtube.com/@MisjaMieszkanie/"
        },
        {
            icon: <XIcon fill="#23232D" wrapperColor="#fff" wrapperSize="2.6" size="2.6" />,
            url: "https://x.com/rynekpierwotny"
        }
    ];

    return (
        <footer className={classNames(styles.footer, props.className)}>
            <div className={styles.panelsWrap}>
                <div className={styles.column}>
                    <img className={styles.logo} height="60px" width="196px" src={props.logoSrc || logoRp} alt="logo" />
                </div>

                <div className={styles.column}>
                    <FooterPanelExpandable title={panelTitles.offers}>
                        <ul className={styles.panelList}>
                            {props.footerMenuData.various.map((element) => (
                                <FooterMenuElement key={element.title.toLowerCase()} {...element} />
                            ))}
                            {props.footerMenuData.cityOffers.map((element) => (
                                <FooterMenuElement key={element.title.toLowerCase()} {...element} />
                            ))}
                        </ul>
                    </FooterPanelExpandable>
                </div>

                <div className={styles.column}>
                    <FooterPanelExpandable title={panelTitles.promotions}>
                        <ul className={styles.panelList}>
                            {props.footerMenuData.promotions.map((element) => (
                                <FooterMenuElement key={element.title.toLowerCase()} {...element} />
                            ))}
                        </ul>
                    </FooterPanelExpandable>

                    <FooterPanelExpandable className={styles.panelMarginMid} title={panelTitles.info}>
                        <ul className={styles.panelList}>
                            {props.footerMenuData.info.map((element) => (
                                <FooterMenuElement key={element.title.toLowerCase()} {...element} />
                            ))}
                        </ul>
                    </FooterPanelExpandable>
                </div>

                <div className={styles.column}>
                    <FooterPanelExpandable title={panelTitles.cooperation}>
                        <ul className={styles.panelList}>
                            {props.footerMenuData.cooperation.map((element) => (
                                <FooterMenuElement key={element.title.toLowerCase()} {...element} />
                            ))}
                        </ul>
                    </FooterPanelExpandable>
                    {props.footerMenuData.topArticles && props.footerMenuData.topArticles?.length > 0 && (
                        <FooterPanelExpandable className={styles.panelMarginMid} title={panelTitles.topArticles}>
                            <ul className={styles.panelList}>
                                {props.footerMenuData.topArticles.map((element) => (
                                    <FooterMenuElement key={element.title.toLowerCase()} {...element} />
                                ))}
                            </ul>
                        </FooterPanelExpandable>
                    )}

                    <FooterContactBox lines={props.contactInfoLines || contactInfoLines} className={styles.contactBox} />

                    <div className={styles.socialIconsHolder}>
                        {socialIcons.map((socialIcon) => (
                            <a
                                className={styles.socialIcon}
                                key={socialIcon.url}
                                href={socialIcon.url}
                                target="_blank"
                                rel="nofollow"
                                data-testid={FOOTER_TEST_IDS.FOOTER_SOCIAL_ICON}
                            >
                                {socialIcon.icon}
                            </a>
                        ))}
                    </div>
                </div>
            </div>

            <div className={styles.copyrightHolder}>
                <Text variant="info_txt_1" as="div" className={styles.copyright}>
                    {props.publisherInfo ? props.publisherInfo : publisherInfo}
                </Text>
            </div>
        </footer>
    );
};
import React from "react";
import classNames from "classnames";

import {FacebookIcon, InstagramIcon, LinkedinIcon, XIcon, YouTubeIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {FOOTER_TEST_IDS} from "@pg-mono/test-ids";

import {FooterContactBox} from "./FooterContactBox";
import {FooterMenuElement, IFooterMenuElement} from "./FooterMenuElement";
import {FooterPanelExpandable} from "./FooterPanelExpandable";

import * as styles from "./Footer.module.css";

const logoRp = require("./Logo-DefaultTextLite.svg");

export interface IProps {
    footerMenuData: IFooterMenuData;
    panelArrowDown: React.JSX.Element;
    hide?: boolean;
    publisherInfo?: string;
    contactInfoLines?: string[];
    className?: string;
    logoSrc?: string;
}

export interface IFooterMenuData {
    various: IFooterMenuElement[];
    cityOffers: IFooterMenuElement[];
    promotions: IFooterMenuElement[];
    info: IFooterMenuElement[];
    cooperation: IFooterMenuElement[];
    topArticles?: IFooterMenuElement[];
}

const panelTitles = {
    offers: "Oferty",
    promotions: "Oferty specjalne",
    info: "Informacje",
    cooperation: "Współpraca",
    topArticles: "Top artykuły"
};

const publisherInfo = "Wydawcą portalu rynekpierwotny.pl jest PropertyGroup Sp. z o.o.";

const contactInfoLines = ["Tel.: +48 22 825 60 71", "Kontakt w dni robocze: 9:00 – 17:00", "E-mail: biuro@rynekpierwotny.pl"];

export const Footer: React.FC<IProps> = (props) => {
    if (props.hide) {
        return null;
    }

    const socialIcons = [
        {
            icon: <FacebookIcon fill="#fff" size="3" />,
            url: "https://www.facebook.com/rynekpierwotnypl/"
        },
        {
            icon: <InstagramIcon fill="#fff" size="3" />,
            url: "https://www.instagram.com/rynekpierwotny/"
        },
        {
            icon: <LinkedinIcon fill="#fff" size="3" />,
            url: "https://www.linkedin.com/company/rynekpierwotny-com/"
        },
        {
            icon: <YouTubeIcon fill="#fff" size="3" />,
            url: "https://www.youtube.com/@MisjaMieszkanie/"
        },
        {
            icon: <XIcon fill="#23232D" wrapperColor="#fff" wrapperSize="2.6" size="2.6" />,
            url: "https://x.com/rynekpierwotny"
        }
    ];

    return (
        <footer className={classNames(styles.footer, props.className)}>
            <div className={styles.panelsWrap}>
                <div className={styles.column}>
                    <img className={styles.logo} height="60px" width="196px" src={props.logoSrc || logoRp} alt="logo" />
                </div>

                <div className={styles.column}>
                    <FooterPanelExpandable title={panelTitles.offers}>
                        <ul className={styles.panelList}>
                            {props.footerMenuData.various.map((element) => (
                                <FooterMenuElement key={element.title.toLowerCase()} {...element} />
                            ))}
                            {props.footerMenuData.cityOffers.map((element) => (
                                <FooterMenuElement key={element.title.toLowerCase()} {...element} />
                            ))}
                        </ul>
                    </FooterPanelExpandable>
                </div>

                <div className={styles.column}>
                    <FooterPanelExpandable title={panelTitles.promotions}>
                        <ul className={styles.panelList}>
                            {props.footerMenuData.promotions.map((element) => (
                                <FooterMenuElement key={element.title.toLowerCase()} {...element} />
                            ))}
                        </ul>
                    </FooterPanelExpandable>

                    <FooterPanelExpandable className={styles.panelMarginMid} title={panelTitles.info}>
                        <ul className={styles.panelList}>
                            {props.footerMenuData.info.map((element) => (
                                <FooterMenuElement key={element.title.toLowerCase()} {...element} />
                            ))}
                        </ul>
                    </FooterPanelExpandable>
                </div>

                <div className={styles.column}>
                    <FooterPanelExpandable title={panelTitles.cooperation}>
                        <ul className={styles.panelList}>
                            {props.footerMenuData.cooperation.map((element) => (
                                <FooterMenuElement key={element.title.toLowerCase()} {...element} />
                            ))}
                        </ul>
                    </FooterPanelExpandable>
                    {props.footerMenuData.topArticles && props.footerMenuData.topArticles?.length > 0 && (
                        <FooterPanelExpandable className={styles.panelMarginMid} title={panelTitles.topArticles}>
                            <ul className={styles.panelList}>
                                {props.footerMenuData.topArticles.map((element) => (
                                    <FooterMenuElement key={element.title.toLowerCase()} {...element} />
                                ))}
                            </ul>
                        </FooterPanelExpandable>
                    )}

                    <FooterContactBox lines={props.contactInfoLines || contactInfoLines} className={styles.contactBox} />

                    <div className={styles.socialIconsHolder}>
                        {socialIcons.map((socialIcon) => (
                            <a
                                className={styles.socialIcon}
                                key={socialIcon.url}
                                href={socialIcon.url}
                                target="_blank"
                                rel="nofollow"
                                data-testid={FOOTER_TEST_IDS.FOOTER_SOCIAL_ICON}
                            >
                                {socialIcon.icon}
                            </a>
                        ))}
                    </div>
                </div>
            </div>

            <div className={styles.copyrightHolder}>
                <Text variant="info_txt_1" as="div" className={styles.copyright}>
                    {props.publisherInfo ? props.publisherInfo : publisherInfo}
                </Text>
            </div>
        </footer>
    );
};
